module.exports = __webpack_public_path__ + "static/media/subscription.254d826b.svg";